<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <p class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </p>
        <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc">{{ inputData.desc }}</p>
        <div class="form__input-container form__input-container--dob">
            <div class="form__input-container--dob-field">
                <label :for="'inputField_' + inputData.id + '_day'">Day</label>
                <input class="form__input form__input--date form__input--day"
                    :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                    type="number"
                    pattern="[1-31]{2}"
                    :id="'inputField_' + inputData.id + '_day'"
                    :name="inputData.id + '_day'"
                    :required="inputData.required"
                    :class="inputData.error ? 'form__input--error' : ''"
                    v-model="day"
                    @change="updateValue()">
            </div>

            <div class="form__input-container--dob-field">
                <label :for="'inputField_' + inputData.id + '_month'">Month</label>
                <input class="form__input form__input--date form__input--month"
                    :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                    type="number"
                    pattern="[1-12]{2}"
                    :id="'inputField_' + inputData.id + '_month'"
                    :name="inputData.id + '_month'"
                    :required="inputData.required"
                    :class="inputData.error ? 'form__input--error' : ''"
                    v-model="month"
                    @change="updateValue()">
            </div>

            <div class="form__input-container--dob-field">
                <label :for="'inputField_' + inputData.id + '_year'">Year</label>
                <input class="form__input form__input--date form__input--year"
                    :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                    type="number"
                    :pattern="'[1900-' + new Date().getFullYear() + ']{4}'"
                    :id="'inputField_' + inputData.id + '_year'"
                    :name="inputData.id + '_year'"
                    :required="inputData.required"
                    :class="inputData.error ? 'form__input--error' : ''"
                    v-model="year"
                    @change="updateValue()">
            </div>
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import RequiredIndicator from './RequiredIndicator.vue';

export default {
    props: ['inputData'],
    emits: ['inputValue'],
    components: {
        'required-indicator': RequiredIndicator
    },
    data() {
        return{
            day: null,
            month: null,
            year: null,
            inputValue: '',
        }
    },
    mounted() {
        if (this.inputData.value) {
            const date = this.inputData.value.split('-');
            this.day   = date[2];
            this.month = date[1];
            this.year  = date[0];
        }
    },
    methods: {
        updateValue() {
            if(!this.year){
                this.year = null;
            }
            if(!this.month){
                this.month = null;
            }
            if(!this.day){
                this.day = null;
            }

            if(!this.day && !this.month && !this.year) {
                this.inputValue = '';
            } else {
                this.inputValue = `${this.year}-${this.month}-${this.day}`;
            }

            this.$emit('inputValue', this.inputData.id, this.inputValue);
        },
    }
}
</script>